<template>
    <div id="app">
        <router-view :key="$route.fullPath" />
        <!-- 法大大模拟返回浮层: 仅 dev/pre 构建 + 后端 mock 模式 (线上构建不渲染) -->
        <fdd-sim-bar v-if="fddSimEnv" />
    </div>
</template>

<script>
import ls from 'local-storage';
import cookie from 'js-cookie';
var md5 = require('js-md5');
import {getMenuList} from '@/assets/js/commonApi';
import FddSimBar from '@/components/FddSimBar/index.vue';

export default {
    name: "App",
    components: { FddSimBar },
    computed:{
        // 环境门控第一道: 仅 dev/pre 构建渲染浮层 (production/preview 之外的构建恒 false)
        fddSimEnv(){
            return ['development','preview'].indexOf(process.env.VUE_APP_ENV) > -1;
        },
        userInfo(){
            return this.$store.state.userInfo || ls.get("userInfo");
        },
        menuList(){
            return this.$store.state.menuList || ls.get("menuList");
        }
    },
    created(){
        const _token = ls.get('token');
        if(!_token){
            ls.set('token',md5( this.$utils.uuid(32).toLowerCase() ))
        }

        const _sign = cookie.get('CUSUT');

        if( _sign ){
            this.$store.commit('setUserInfo',this.userInfo);
        }


        if( _sign ){
            // 登录态每次页面加载实时拉取菜单与灰度标记 (P0-0: 关灰度后刷新即回退, localStorage 仅作拉取返回前的首屏兜底)
            if( this.menuList ) this.$store.commit('setMenuList',this.menuList);
            getMenuList();
        }else{
            this.$store.commit('setMenuList',this.menuList);
        }
    }
};
</script>

<style lang="scss">
// @import "@/assets/iconfont/iconfont.css";
@import "@/assets/css/common.scss";
</style>
